import { render } from "./InstalledIntegration.vue?vue&type=template&id=7d7c76dc&ts=true"
import script from "./InstalledIntegration.vue?vue&type=script&lang=ts"
export * from "./InstalledIntegration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QImg});
